<button class="dropdown-button" [matMenuTriggerFor]="menu">
  <mat-icon id="tune-icon" class="icon"> tune </mat-icon>
  <span>
    <ng-content> </ng-content>
  </span>
  <mat-icon id="arrow-icon" class="icon"> arrow_drop_down </mat-icon>
</button>

<mat-menu id="menu" #menu="matMenu">
  <button
    *ngFor="let opcao of opcoes"
    class="mat-menu-item"
    mat-menu-item
    (click)="chamarAcao(opcao.acao)"
  >
    <mat-icon>{{ opcao.icone }}</mat-icon>
    <span class="menu-label">{{ opcao.rotulo }}</span>
  </button>
</mat-menu>
